__turbopack_context__.v({
  "fuelFilter": "FuelFilter-module__lourEW__fuelFilter",
  "listItem": "FuelFilter-module__lourEW__listItem",
});
